export const WORD = 'WORD';
export const PRONOUNCE = 'PRONOUNCE';
export const DEFI = 'DEFI';
export const EX = 'EX';
export const LEFT = 'LEFT';
export const RIGHT = 'RIGHT';
export const RIGHT1 = 'RIGHT1';
export const IMG = 'IMG';
